module.exports = __webpack_public_path__ + "static/media/16UNODC12.9ecf861b.jpg";